import React from 'react'
import styled from '@emotion/styled'
import { fontSize2XSmall, fontWeightBold } from '../../../constants/principles'
import Compare from './AssessmentCompare'

export default () => (
  <>
    <SvgDiv>
      <Compare />
    </SvgDiv>
    <TextDiv fontWeight={fontWeightBold}>Ask for the Side-by-Side View</TextDiv>
    <TextDiv>You may not have caught everything when assessing your vehicle. That's OK. After the dealer’s inspection, you’ll get an email with any updates so you can agree on what’s fair.</TextDiv>
  </>
)

const TextDiv = styled.div`
  font-size: ${fontSize2XSmall};
  max-width: 650px;
  width: 100%;
  margin: auto;
  ${p => p.fontWeight && `font-weight: ${p.fontWeight};`}
`
const SvgDiv = styled.div`
  padding-top: 16px;
  padding-bottom: 32px;
`
